export default "__VITE_ASSET__DpNuQxhZ__"